module.exports = __webpack_public_path__ + "img/angle-down-solid.ab6f12a9.svg";